export default "__VITE_ASSET__fKZnFDTR__"